import globalConfig from "../utiles/globalConfig";
import { SHOW_NOTICE } from "../store/web/h5";

export default {
  data() {
    return {
      extraCoinDownContent:
        "尊敬するプレイヤーの皆様：\n\nプレミアムセンターの優待券配布戦略の評価に基づき、以下の調整を行うことになりました:\n\n2025年11月6日17:00 (utc+9) より、優待券の配布を停止いたします。\n\nそのため、ポイントショップで交換可能なアイテムの種類を増やし、より良い交換体験を提供できるよう努めてまいります。\n\nなお、2025年11月6日17:00 (utc+9) 以前に受け取られた優待券は、その有効期限まで引き続きご利用いただけます。\n\nさらに、2025年11月6日17:00 (utc+9) より、チャージイベントに以下の調整を行います：\n1.プレミアムセンターのチャージミッションは、アプリ内課金（App StoreおよびGoogle Playストア経由）でのみ参加可能となります。\n2.現行の公式イベント「合計チャージ額で報酬GET」は終了し、ゲーム内に新たなイベントが登場します。毎日指定の金額をアプリ内でチャージすることで、豪華なゲームアイテムを受け取ることができます。\n\n今回の調整によりご不便をおかけすることを深くお詫び申し上げます。プレイヤーの皆様の変わらぬご支援とご理解に心より感謝申し上げます。",
      thirdPartyPaymentDownContent:
        `親愛なる【旦那】様：\n\n日頃のご愛顧誠にありがとうございます。より安全な決済環境を提供するため、\n【2025年12月1日 17:00(日本時間)】に以下の決済システム調整を実施いたします：\n公式サイトのチャージプラットフォーム【および / PCでの決済機能 / ブラウザゲームの決済機能】のサービスを終了\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\n終了後は以下の公式チャネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\n注意事項\n1. 公式サイトのチャージクーポンの配布も同時に終了しますが、2025年12月1日 17:00(日本時間)までに受け取ったクーポンは有効期限まで使用可能です。\n2. 公式サイトのチャージプラットフォームで既にチャージしたゲーム内通貨やアイテムは引き続き通常通り使用できます。\n3. 一部の決済方法（コンビニ払い/クレジットカードなど）では入金に遅延が生じる場合があります。2025年12月1日 17:00(日本時間)までにチャージが反映されない場合（弊社で入金が確認できない場合）、そのチャージは自動的に無効となりますので、チャージのタイミングにご注意ください。\n\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\n\nご理解とご支援に重ねて感謝申し上げます。\n\n【旦那様の一発逆転人生】運営チーム\n2025年11月24日`,
    };
  },
  methods: {
    // 检查是否在展示时间范围内
    isInDisplayPeriod(startTime, endTime) {
      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);
      return now >= startDate && now <= endDate;
    },
    // 获取当前UTC日期字符串 (YYYY-MM-DD)
    getCurrentUTCDateString() {
      const now = new Date();
      return now.toISOString().split("T")[0];
    },
    // 检查今天是否已经弹出过
    hasShownToday(cookieName) {
      const today = this.getCurrentUTCDateString();
      const lastShownDate = globalConfig.getCookie(cookieName);
      return lastShownDate === today;
    },
    // 检查是否应该显示弹窗（每日一次，总共最多3次）
    shouldShowPopupWithLimit(
      startTime,
      endTime,
      dateCookieName,
      countCookieName,
      maxCount = 3
    ) {
      // 1. 检查是否在展示时间范围内
      if (!this.isInDisplayPeriod(startTime, endTime)) {
        return false;
      }

      // 2. 检查今天是否已经弹出过
      if (this.hasShownToday(dateCookieName)) {
        return false;
      }

      // 3. 检查总弹出次数是否达到上限
      const totalCount = parseInt(
        globalConfig.getCookie(countCookieName) || "0"
      );
      if (totalCount >= maxCount) {
        return false;
      }

      return true;
    },
    // 记录今天已经弹出
    markAsShownToday(cookieName) {
      const today = this.getCurrentUTCDateString();
      globalConfig.setCookie(cookieName, today);
    },
    // 记录弹出并增加计数
    markAsShownTodayWithCount(dateCookieName, countCookieName) {
      // 记录今天已弹出
      this.markAsShownToday(dateCookieName);

      // 增加总计数
      const currentCount = parseInt(
        globalConfig.getCookie(countCookieName) || "0"
      );
      globalConfig.setCookie(countCookieName, (currentCount + 1).toString());
    },
    showTipPopupEntry() {
      try {
        // 如果是mobage和dmm平台就不要弹窗
        const curHref = window.location.href;
        const isDmm =
          curHref.indexOf("transaction_id=") !== -1 &&
          curHref.indexOf("h=") !== -1;
        const isMobage = !!globalConfig.getHrefParamUndecode("fromMobage");
        if (isDmm || isMobage) {
          return;
        }

        this.jpThirdPartyPaymentDownTip();
      } catch (e) {
        console.error(e);
      }
    },
    jpExtraCoinDownTip() {
      if (
        this.isInDisplayPeriod(
          "2025-10-30T17:00:00+08:00",
          "2025-11-13T23:59:59+08:00"
        ) &&
        [2].includes(Number(window.gameId))
      ) {
        if (
          this.isInDisplayPeriod(
            "2025-10-30T17:00:00+08:00",
            "2025-11-06T23:59:59+08:00"
          )
        ) {
          this.$store.commit(SHOW_NOTICE, this.extraCoinDownContent);
        } else {
          const dateCookieName = `jp_game_coupon_down_${window.gameId}_mark`;
          const countCookieName = `jp_game_coupon_down_${window.gameId}_count`;
          if (
            this.shouldShowPopupWithLimit(
              "2025-11-07T00:00:00+08:00",
              "2025-11-13T23:59:59+08:00",
              dateCookieName,
              countCookieName,
              7
            )
          ) {
            this.$store.commit(SHOW_NOTICE, this.extraCoinDownContent);
            this.markAsShownTodayWithCount(dateCookieName, countCookieName);
          }
        }
      }
    },
    jpThirdPartyPaymentDownTip() {
      if (
        this.isInDisplayPeriod(
          '2025-11-24T11:00:00+09:00',
          '2025-12-31T23:59:59+09:00'
        ) &&
        [2].includes(Number(window.gameId))
      ) {
        const dateCookieName = `jp_game_third_party_payment_down_${window.gameId}_mark`;
        const countCookieName = `jp_game_third_party_payment_down_${window.gameId}_count`;
        if (
          this.shouldShowPopupWithLimit(
            '2025-11-24T11:00:00+09:00',
            '2025-12-31T23:59:59+09:00',
            dateCookieName,
            countCookieName,
            100000
          )
        ) {
          this.$store.commit(SHOW_NOTICE, this.thirdPartyPaymentDownContent);
          this.markAsShownTodayWithCount(dateCookieName, countCookieName);
        }
      }
    },
  },
};
